import { Component } from 'preact'
import globals from '../../utils/globals'
import { InstantSearch, Configure } from 'react-instantsearch-dom'
import SuggestedTopicsListContainer from './SuggestedTopicsListContainer'
import CustomSearchBox from './SearchBox'
import algoliasearch from 'algoliasearch/lite'
import { getSearchToken } from '../../services/algoliaService'

class TopicSuggestion extends Component {
  constructor () {
    super()
    this.communityId = globals('communityId')
    this.state = {
      hideSuggestions: true
    }
    this.cb = this.cb.bind(this)
  }

  cb (data) {
    this.setState({
      clientId: data.client_id,
      token: data.token
    })
  }

  componentDidMount () {
    getSearchToken(this.cb)
  }

  render (props, state) {
    if (!state.clientId || !state.token) return null
    return (
      <div className='topic-create_suggestions-wrapper'>
        <InstantSearch
          searchClient={props.searchClient || algoliasearch(state.clientId, state.token, { hosts: props.hosts })}
          indexName={this.communityId}
        >
          <Configure
            hitsPerPage={7}
            analyticsTags={['destination', 'topic creation suggestion']}
          />
          <CustomSearchBox
            defaultCdn={props.defaultCdn}
            hideSuggestionsCallback={(value) => this.setState({ hideSuggestions: value })}
          />
          {
            !state.hideSuggestions && <SuggestedTopicsListContainer />
          }
        </InstantSearch>
      </div>
    )
  }
}

export default TopicSuggestion
